// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"RecVideoSwitch_modalTitle__2mk0O","addRecVideo":"RecVideoSwitch_addRecVideo__2D2_9","switch":"RecVideoSwitch_switch__2vjHZ"};